import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { FullscreenExitOutlined, FullscreenOutlined, ToolOutlined } from '@ant-design/icons';
import styles from './index.module.scss';

interface ScreenHeaderProps {
  fullscreen: boolean;
  onRecalculate: () => void;
  onToggleFullscreen: () => void;
}

const ScreenHeader: React.FC<ScreenHeaderProps> = ({ fullscreen, onRecalculate, onToggleFullscreen }) => {
  const [time, setTime] = useState(() => dayjs().format('YYYY年M月D日 dddd HH:mm:ss'));

  useEffect(() => {
    const timer = window.setInterval(() => setTime(dayjs().format('YYYY年M月D日 dddd HH:mm:ss')), 1000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className={styles.header}>
      <div className={styles.time}>{time}</div>
      <div className={styles.title}>供能韧性分析</div>
      <div className={styles.actions}>
        <button type="button" onClick={onRecalculate}>
          <ToolOutlined />
          <span>重计算</span>
        </button>
        <button type="button" onClick={onToggleFullscreen}>
          {fullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
          <span>{fullscreen ? '退出全屏' : '全屏'}</span>
        </button>
      </div>
    </div>
  );
};

export default ScreenHeader;
